import API from '../../../../common/http/api.fetch';
import {success, responseMessage} from '../../../../common/utils/util.notifier';
import * as GRID from '../../../../common/grid/grid.constants';
import { TYPES } from '../adm-categorisation-action-type.constants';
import { IDS } from '../adm-categorisation-action-id.constants';
import I18N from '../../../../common/utils/util.i18n';
import {GRID_FETCH} from "../../../../common/grid/grid.constants";

export const fetchSiteCapabilitiesGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url: '/location/site-capabilities',
            method: 'GET',
            params: {par_code: 'scapab'}
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.admCategorisation,
                path:   IDS.admCatCapabilitiesGrid,
                items: data,
            })
        }, error => {
            responseMessage(error);
        })
    }
}

export const getCapabilityTypeDetails = (typeId) => {
    return dispatch => {
        return API.fetch({
            url:    '/categorisation/site-capability-details',
            method: 'GET',
            params: { typeId }
        }).then(response => {
            const key = `ACCREDITATION.SETTINGS.SCHEME.STATUS_${response.data.details.status_code.toUpperCase()}`
            let status_name = I18N.translate(key);
            if(status_name === key)
                status_name = response.data.details.status_name;
            dispatch({
                type:   TYPES.CENTER_DETAILS_REFRESH,
                id:     IDS.accreditationSettingsFrameworkDetails,
                data: {
                    ...response.data.details,
                    status_name,
                }
            });
            return response.data.details
        }, error => {
            responseMessage(error);
        });
    };
}
